const routes = {
  shifts: 'Horas de trabajo',
  passengers: 'Empleados'
};

export default routes;
